import React from 'react';

import { IIconProps, TIconType } from '../interface';

const FullViewIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<g clipPath='url(#clip0_24123_498569)'>
				<path
					d='M15 4.5H3.75C3.33579 4.5 3 4.83579 3 5.25V18.75C3 19.1642 3.33579 19.5 3.75 19.5H20.25C20.6642 19.5 21 19.1642 21 18.75V8'
					stroke={props?.color || '#2E2E6B'}
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M7.125 9H16.875'
					stroke={props?.color || '#2E2E6B'}
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M7.125 12H16.875'
					stroke={props?.color || '#2E2E6B'}
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M7.125 15H16.875'
					stroke={props?.color || '#2E2E6B'}
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M18.5 1L22.25 1V4.75'
					stroke={props?.color || '#2E2E6B'}
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M17 6.25L22.25 1'
					stroke={props?.color || '#2E2E6B'}
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</g>
			<defs>
				<clipPath id='clip0_24123_498569'>
					<rect
						fill='white'
						height='24'
						width='24'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default FullViewIcon;
